import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "components";
import { getApi, patchApi, postApi } from "lib";
import { API_ERROR, maskSensitiveInfo } from "utils/constant";
import { encryptPasswordIfEnabled } from "../../../utils/passwordEncryption";
import { CALLBACKREQUEST } from "services";


// export const getLogin = createAsyncThunk(
//   "auth/getLogin",
//   async ({ phone, userType = "healon",token, next }, thunkAPI) => {
//     try {
//       const response = await postApi(
//         `phonesignin/?username=91${phone}&user_type=${userType}&token=${token}` //# TODO add international code here
//       );
//       await  localStorage.setItem(
//         "auth",
//         JSON.stringify(response?.data?.data)
//       );
//       next();
//       message.success(response?.data?.data?.message);
//       return response?.data?.data;
//     } catch (error) {
//       message.error(error?.response?.data?.data?.message || API_ERROR);
//       return thunkAPI.rejectWithValue(error.response.data.message);
//     }
//   }
// );

export const getLogin = createAsyncThunk(
  "auth/getLogin",
  async ({ phone, userType = "healon", token, next }, thunkAPI) => {
    try {
      const body = {
        username: `91${phone}`,
        user_type: userType,
        token: token,
      };

      const response = await postApi(`phonesignin/`, body);

      await localStorage.setItem(
        "auth",
        JSON.stringify(response?.data?.data)
      );

      next();
      message.success(response?.data?.data?.message);

      return response?.data?.data;
    } catch (error) {
      message.error(error?.response?.data?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error?.response?.data?.message);
    }
  }
);

// export const getOtp = async (payload) => {
//   try {
//     const response = await getApi(
//       `/sendotp/?phno=${payload?.phone}&otp_type=register&country_code=91&user_type=${payload?.userType || "healon"  //# TODO add international code here
//       }`
//     );
//     if (response?.data?.status == 200) {
//       message.success(
//         "OTP sent successfully to your " + maskSensitiveInfo(payload?.phone)
//       );
//       return response?.data?.data;
//     } else {
//       message.error(response?.data?.message || API_ERROR);
//     }
//   } catch (error) {
//     message.error(error?.response?.data?.message || API_ERROR);
//   }
// };


export const getOtp = async (payload) => {
  try {
    const body = {
      phno: payload?.phone,
      otp_type: "register",
      country_code: 91,
      user_type: payload?.userType || "healon",
    };

    const response = await postApi(`/sendotp/`, body);

    if (response?.data?.status == 200) {
      message.success(
        "OTP sent successfully to your " +
        maskSensitiveInfo(payload?.phone)
      );
      return response?.data?.data;
    } else {
      message.error(response?.data?.message || API_ERROR);
    }
  } catch (error) {
    message.error(error?.response?.data?.message || API_ERROR);
  }
};

// export const getOTPVerify = async (payload) => {
//   try {
//     const response = await postApi(
//       `verifyotp/?otp=${payload.otp}&message_id=${payload.message}&user_type=${payload?.userType || "healon"
//       }`
//     );
//     if (response?.data?.status == 200) {
//       return response?.data;
//     }
//   } catch (error) {
//     message.error(error?.response?.data?.message || API_ERROR);
//   }
// };

export const getOTPVerify = async (payload) => {
  try {
    const body = {
      otp: payload.otp,
      message_id: payload.message,
      user_type: payload?.userType || "healon",
    };

    const response = await postApi(`verifyotp/`, body);

    if (response?.data?.status == 200) {
      return response?.data;
    }
  } catch (error) {
    message.error(error?.response?.data?.message || API_ERROR);
  }
};

export const postLoginOTP = async (payload) => {
  try {
    const response = await postApi(`findcare/signin?user_role=healon`, {
      phone: payload,
      user_role: "healon",
      country_code: "91"    //# TODO add international code here
    });
    return response?.data;
  } catch (error) {
    // message.info(error?.response?.data?.message || API_ERROR);
    return error?.response?.data;
  }
};

export const postSignUp = async ({ body, next }) => {
  try {
    const encryptedPassword = await encryptPasswordIfEnabled(body?.password);
    const requestBody = body?.password
      ? { ...body, password: encryptedPassword }
      : body;

    const response = await postApi(`findcare/signup?user_role=healon`, {
      ...requestBody,
      user_role: "healon",
    });
    if (response?.data?.success) {
      next();
      message.success(response?.data?.message);
    }
    return response?.data;
  } catch (error) {
    message.error(error?.response?.data?.message || API_ERROR);
  }
};

export const postLogin = (body, next) => {
  return async (dispatch) => {
    try {
      const encryptedPassword = await encryptPasswordIfEnabled(body?.password);
      const requestBody = body?.password
        ? { ...body, password: encryptedPassword }
        : body;

      const response = await postApi(`signin/`, requestBody);
      const data = response?.data;

      if (data?.success) {
        localStorage.setItem("auth", JSON.stringify(data));
        message.success(data?.message || "Login Successful");
        if (typeof next === "function") next(); // ✅ navigate happens here
      } else {
        message.error(data?.message || "Login failed. Try again.");
      }

      return data;
    } catch (error) {
      message.error(error?.response?.data?.message || "Something went wrong");
    }
  };
};



export const sendotpemail = async (email) => {
  try {
    const body = {
      username: email,
    };

    const response = await postApi(`resetpassword/`, body);

    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

// export const verifyemailotp = async (email, otp, filetype = "email") => {
//   try {
//     const res = await postApi(`verifyotp/?mail=${email}&otp=${otp}&filetype=email`);
//     return res?.data;
//   } catch (error) {
//     return error?.response?.data;
//   }
// };

export const verifyemailotp = async (email, otp, filetype = "email") => {
  try {
    const res = await postApi("verifyotp/", {
      mail: email,
      otp: otp,
      filetype: filetype,
    });
    return res?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const resetpasswordapi = (body) => async () => {
  try {
    const encryptedPassword = await encryptPasswordIfEnabled(body?.password);
    const requestBody = body?.password
      ? { ...body, password: encryptedPassword }
      : body;

    const res = await patchApi("set-new-password/", requestBody);

    if (res?.data?.success) {
      message.success(res?.data?.message);
      return true; // ✅ IMPORTANT
    }
    return false;
  } catch (error) {
    message.error(error?.response?.data?.message || API_ERROR);
    return false;
  }
};


export const callbackrequest = async (payload) => {
  try {
    const res = await postApi(CALLBACKREQUEST, {
      is_from_web: true,
      ...payload,
    });
    if (res?.data?.success) {
      message.success(res?.data?.message);
    }
    return res.data;
  } catch (error) {
    throw error;
  }
};


export const logoutuser = async () => {
  const getAuthTokens = () => JSON.parse(localStorage.getItem("auth"));
  const refreshToken = getAuthTokens()?.refresh;
  try {
    const response = await postApi(`logout/`, { refresh: refreshToken });
    if (response?.data?.success) {
      message.success(response?.data?.message);
    }
    return response?.data;
  } catch (error) {
    message.error(error?.response?.data?.message || API_ERROR);
  }
};
